import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxFuelPrices from "../../util/remote/ajaxFuelPrices";
import RegisterFuelPriceModal from "./RegisterFuelPriceModal";
import UpdateStationFuelPriceModal from "../fuelTanks/UpdateStationFuelPriceModal";
const FuelPricesTable = () => {
  var station_idd = Number(window.localStorage.getItem("FuelFy@station_id"));
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [prices, setPrices] = useState([]);
  const [station_id, setstation_id] = useState(station_idd); // default
  const fetchPrices = async () => {
    setLoading(true);
    const data = { station_id };
    const response = await ajaxFuelPrices.list_Prices(data); // you might want to rename this to list_Prices
    if (response.status === "OK") {
      setPrices(response.details || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchPrices();
  }, [station_id]);
  const [update, setUpdate] = useStateCallback(false);
  const handleViewDetails = (price) => {
    setUpdate(false, () =>
      setUpdate(<UpdateStationFuelPriceModal data={price} func={fetchPrices} />)
    );
  };
  return (
    <>
      <div className="container-fluid">
        <Toaster />
        {update}
        <div className="row">
          <div className="table-responsive">
            <table className="table table-bordered text-nowrap mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Fuel</th>
                  <th>Selling Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(prices) &&
                  prices.map((price, index) => (
                    <tr key={price.id}>
                      <td>{index + 1}</td>
                      <td>{price.fuel_category}</td>
                      <td>{price.selling_price}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-info"
                          onClick={() => handleViewDetails(price)}
                        >
                          <i className="fe fe-edit-2"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
export default FuelPricesTable;
